import React, { ChangeEvent, MouseEvent } from 'react';
import styled from 'styled-components';

import CartItemClass from 'src/state/cart-item';

import useErnie from 'shared/hooks/use-ernie';
import useCart from 'src/hooks/use-cart';
import useCustomerState from 'src/hooks/use-customer-state';

import { Option, Select } from 'components/core';
import { makeStyles } from '@material-ui/core';

type WeightOption = {
  value: string;
  label: string;
  price: string;
};

type WeightDropdownProps = {
  item: CartItemClass;
  selectedWeight: string;
  weightOptions: WeightOption[];
};

export const WeightDropdown = ({ item, selectedWeight, weightOptions }: WeightDropdownProps): JSX.Element => {
  const { changeItemWeight } = useCart();
  const customerState = useCustomerState();
  const showErnie = useErnie();

  // Matches styling from the quantity dropdown
  const useWeightSelectStyles = makeStyles({
    paper: {
      width: 100,
    },
    list: {
      '& li': {
        height: `35px`,
        minHeight: `0`,
        paddingLeft: `23px`,
      },
    },
  });

  const weightSelectClasses = useWeightSelectStyles();

  const handleWeightChange = (e: ChangeEvent<HTMLSelectElement>): void => {
    e.stopPropagation();

    const { value } = e.target;

    if (value === selectedWeight) {
      return;
    }

    changeItemWeight(item, value, showErnie, customerState);
  };

  return (
    <StyledSelect
      SelectDisplayProps={{
        'aria-label': 'Weight',
        'data-testid': 'weight-select',
      }}
      MenuProps={{ classes: { paper: weightSelectClasses.paper, list: weightSelectClasses.list } }}
      value={selectedWeight}
      onChange={handleWeightChange}
      onClose={(e: MouseEvent<HTMLDivElement>) => e.stopPropagation()}
    >
      {weightOptions.map(({ label, value }) => (
        <Option key={value} value={value} data-testid={value}>
          {label}
        </Option>
      ))}
    </StyledSelect>
  );
};

const StyledSelect = styled(Select)`
  border: none !important;

  .MuiSelect-root {
    border: none;
    color: #646d72;
    font-size: 12px;
    height: auto;
    line-height: 1;
    padding-left: 0;
  }

  svg {
    color: #485055;
  }
`;
